import { render, staticRenderFns } from "./AdminGlobalSearch.vue?vue&type=template&id=e0c12432"
import script from "./AdminGlobalSearch.vue?vue&type=script&lang=js"
export * from "./AdminGlobalSearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports